import React, { useEffect, useState, useRef } from 'react';
import "./ScheduleConfirm.scss";
import ModalComponent from '../ModalComponent/ModalComponent';

const ScheduleConfirm = ({ isConfirmed = false, isCleared = false, handleClick = null, handleClear = null, handleFill = null }) => {
    const [confirm, setConfirm] = useState(isConfirmed);
    const [cleared, setCleared] = useState(isCleared);
    const [clearModalOpen, setClearModalOpen] = useState(null);
    const [confirmModalOpen, setConfirmModalOpen] = useState(null);

    const handleConfirm = () => {
        handleClick();
        setConfirm(true);
        setConfirmModalOpen(false);
    };

    const handleCleared = () => {
        handleClear();
        setClearModalOpen(false)
        setCleared(true);
    };

    const handleCreate = () => {
        handleFill();
    };

    useEffect(() => {
        setConfirm(isConfirmed);
    }, [isConfirmed]);

    return (
        <div className="schedule-confirm">
            <div className={"schedule-confirm__inner " + (confirm ? "confirm" : "")}>
                <div className="schedule-confirm__button draw">
                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.39063 7.89062H6.46875C5.97976 7.89062 5.51079 8.08488 5.16502 8.43065C4.81925 8.77642 4.625 9.24538 4.625 9.73437V18.0312C4.625 18.5202 4.81925 18.9892 5.16502 19.335C5.51079 19.6807 5.97976 19.875 6.46875 19.875H14.7656C15.2546 19.875 15.7236 19.6807 16.0694 19.335C16.4151 18.9892 16.6094 18.5202 16.6094 18.0312V17.1094" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M19.7299 7.50815C20.093 7.14507 20.297 6.65263 20.297 6.13916C20.297 5.62569 20.093 5.13325 19.7299 4.77018C19.3668 4.4071 18.8744 4.20313 18.3609 4.20312C17.8475 4.20312 17.355 4.4071 16.992 4.77018L9.23438 12.5001V15.2657H12L19.7299 7.50815Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M15.6875 6.04688L18.4531 8.8125" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <span>Черновик</span>
                </div>
                {!isCleared && !confirm ?
                    <>
                        <div className="schedule-confirm__button confirm">
                            <ModalComponent
                                isOpen={confirmModalOpen}
                                isFormModal={true}
                                button={<button className="g-button" onClick={() => setConfirmModalOpen(true)}><span>Утвердить</span></button>}>
                                <div className="confirm-modal">
                                    <div className="confirm-modal__headline">
                                        Подтверждение
                                    </div>
                                    <div className="confirm-modal__description">
                                        Вы действительно хотите утвердить график?
                                    </div>
                                    <div className="confirm-modal__btns">
                                        <button className='g-button' onClick={handleConfirm}>Утвердить</button>
                                        <button className='g-button-secondary' onClick={() => setConfirmModalOpen(false)}>Отменить</button>
                                    </div>
                                </div>
                            </ModalComponent>
                        </div>
                        <div className="schedule-confirm__button clear">

                            <ModalComponent
                                isOpen={clearModalOpen}
                                isFormModal={true}
                                button={<div className="g-button g-button-error" onClick={() => setClearModalOpen(true)}>Очистить</div>}
                            >
                                <div className="confirm-modal">
                                    <div className="confirm-modal__headline">
                                        Подтверждение
                                    </div>
                                    <div className="confirm-modal__description">
                                        Вы действительно хотите очистить график?
                                    </div>
                                    <div className="confirm-modal__btns">
                                        <button className='g-button g-button-error' onClick={handleCleared}>Очистить</button>
                                        <button className='g-button-secondary' onClick={() => setClearModalOpen(false)}>Отменить</button>
                                    </div>
                                </div>
                            </ModalComponent>

                        </div>
                    </> :
                    <>
                        <div className="schedule-confirm__button confirm">
                            <button className="g-button" onClick={handleCreate}>
                                <span>Заполнить график</span>
                            </button>
                        </div>
                    </>
                }
                <div className="schedule-confirm__access">
                    <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7304 0.31701C16.1076 0.720412 16.0864 1.35322 15.683 1.73043L6.058 10.7304C5.67363 11.0898 5.07649 11.0899 4.69209 10.7305L0.317091 6.6405C-0.0863533 6.26334 -0.107659 5.63054 0.269504 5.22709C0.646666 4.82365 1.27947 4.80234 1.68292 5.1795L5.37493 8.63101L14.317 0.269579C14.7204 -0.107628 15.3532 -0.0863925 15.7304 0.31701Z" fill="#78AD42" />
                    </svg>
                    <span>График утвержден</span>
                </div>
            </div>
        </div>
    );
};

export default ScheduleConfirm;
